import React from 'react';

// Spice level (0-5) as chilli icons. 0 / missing renders nothing at all.
// Same scale on every app: 1 Mild, 2 Medium, 3 Hot, 4 Very hot, 5 Extra hot.
const SPICE_LABELS = ['', 'Mild', 'Medium', 'Hot', 'Very hot', 'Extra hot'];

/** Accepts a number (or numeric string) and returns an integer clamped to 0-5. Anything else = 0. */
export const normalizeSpice = (raw) => {
  const n = typeof raw === 'string' ? parseInt(raw, 10) : raw;
  if (typeof n !== 'number' || !Number.isFinite(n)) return 0;
  return Math.min(Math.max(Math.round(n), 0), 5);
};

const SpiceLevel = ({ level, size = 13, style }) => {
  const n = normalizeSpice(level);
  if (n <= 0) return null;
  return (
    <span
      role="img"
      className="spice-level"
      title={`Spice level ${n} of 5 — ${SPICE_LABELS[n]}`}
      aria-label={`Spice level ${n} of 5, ${SPICE_LABELS[n]}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        background: '#FEF2F2',
        border: '1px solid #FECACA',
        borderRadius: 999,
        padding: `${Math.round(size * 0.18)}px ${Math.round(size * 0.4)}px`,
        fontSize: size,
        lineHeight: 1,
        verticalAlign: 'middle',
        ...style,
      }}
    >
      {Array.from({ length: n }, (_, i) => (
        <span key={i} aria-hidden="true">🌶️</span>
      ))}
    </span>
  );
};

export default SpiceLevel;
